import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mercIcon",
  "use": "icon-mercIcon-usage",
  "viewBox": "0 0 42 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 15\" id=\"icon-mercIcon\">\n    <g data-name=\"组 7434\" transform=\"translate(-165 -214)\">\n        <rect data-name=\"矩形 3017\" width=\"42\" height=\"15\" rx=\"7.5\" transform=\"translate(165 214)\" style=\"fill:#ff00d8\" />\n        <text transform=\"translate(170 224)\" style=\"fill:#130f32;font-size:8px;font-family:PingFangHK-Medium,PingFang HK;font-weight:500\"><tspan x=\"0\" y=\"0\">认证商家</tspan></text>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol